<template>
    <b-card>
        <b-form-group>
        <b-form>
            <b-input
                    style="display: inline;width: 20%"
                    id="wallet_name"
                    v-model="walletName"
                    class="mb-2 mr-sm-2 mb-sm-0"
                    placeholder="نام کیف پول"
            ></b-input>
            <b-button style="display:block;margin-top: 20px" variant="primary" @click="addNewWallet">ایجاد کیف پول</b-button>
        </b-form>
        </b-form-group>
    </b-card>
</template>
<script>
    import httpHelper from "../../helpers/httpHelper";

    export default {
        name: "addWallet",
        data: function () {
            return {
                walletName:null
            }
        },
        methods:{
            addNewWallet: function () {
                httpHelper.postData("wallets",{
                    wallet_name:this.walletName
                }).then(response=>{

                })
            }
        },
        created() {
            httpHelper.setAuth()
        }
    }
</script>